import {
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import UserLanguagePreference from '../../../../components/Enums/UserLanguagePreference';
import Button from '../../../../components/UIButton/UIButton';
import BootstrapSelect from '../../../../components/BootstrapSelect/BootstrapSelect';

export default function UserPreferencesSection({ modalData, handleChange }) {
    const languageOptions = Object.entries(UserLanguagePreference).map(([key, value]) => ({
        value,   // the enum value
        label: key, // the display name
    }));
 
    return (
        <>
            {/* Language Preference */}
            <FormGroup className="d-flex align-items-center mb-3">
                <Label className="mb-0 me-3 mr-3" style={{ minWidth: '150px' }}>
                    Language Preference
                </Label>
                <BootstrapSelect
                    options={languageOptions}
                    value={languageOptions.find(opt => opt.value === modalData.userData.languagePreference)}
                    name="languagePreference"
                    onChange={(val) =>
                        handleChange({ target: { name: "languagePreference", value: val.value } })
                    }
                    size="sm"
                    width="200px"
                />
                

            </FormGroup>

            {/* Category Preferences */}
            <FormGroup className="d-flex align-items-center mb-3">
                <Label className="mb-0 me-3 mr-3" style={{ minWidth: '150px' }}>
                    Category Preferences
                </Label>
                <Button variant="primary" size="small" className="me-2" onClick={(e) => e.preventDefault()}>
                    Edit
                </Button>
            </FormGroup>
        </>
    )
}